import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Universal back button used at the top-left of every sub-page.
 * - Uses browser history if available; otherwise falls back to a safe route.
 * - Renders on desktop AND mobile with a comfortable ≥40px touch target.
 */
export function BackButton({ fallback = "/dashboard", label = "Back", className = "" }) {
  const navigate = useNavigate();

  const goBack = () => {
    // If there's real history (user came from within the app), go back.
    // Otherwise route to the safe fallback so a direct link doesn't dead-end.
    if (window.history.length > 1 && document.referrer && document.referrer.includes(window.location.host)) {
      navigate(-1);
    } else if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  };

  return (
    <button
      type="button"
      onClick={goBack}
      data-testid="back-btn"
      aria-label={label}
      className={`inline-flex items-center gap-1.5 text-xs font-medium text-ink-secondary hover:text-ink border border-line hover:bg-bg-hover transition-colors rounded-sm px-2.5 py-2 active:scale-[0.98] ${className}`}
      style={{ minHeight: 40 }}
    >
      <ArrowLeft size={14} />
      <span>{label}</span>
    </button>
  );
}
